import * as React from 'react';

import { HELP_ARTICLE_LINKS } from '@showbie-socrative/socrative-utils/lib/consts/constants';
import { translate } from '~l10n/client';

import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { AlertMessage } from '~shared/components/AlertMessage';
import { SmallButton } from '~shared/components/buttons';
import { Link } from '~shared/components/Link';
import { useQuizLimit } from '~teacher/hook';

const QUIZ_LIMIT_PERCENT_THRESHOLD = 0.8;

function isUnderQuizThreshold({
  quizCount = 0,
  limit = Infinity,
}: {
  quizCount: number;
  limit: number;
}) {
  return quizCount < limit * QUIZ_LIMIT_PERCENT_THRESHOLD;
}

export function QuizLimit() {
  const quizLimit = useQuizLimit();

  if (quizLimit.isLoading) {
    return <div data-testid="loading-limit"></div>;
  }

  if (
    isUnderQuizThreshold({
      quizCount: quizLimit.data?.currentQuizCount,
      limit: quizLimit.data?.limit,
    })
  ) {
    return <div data-testid="no-limit"></div>;
  }

  const displayQuizCount = Math.min(
    quizLimit.data.currentQuizCount,
    quizLimit.data.limit
  );

  return (
    <div
      className="flex items-center justify-start pb-3"
      data-testid="quiz-limit"
    >
      <div className="flex-grow">
        <AlertMessage tone={'promote'}>
          <div className="flex flex-col gap-3 justify-between md:flex-row md:items-center">
            <div>
              {translate(
                '{0} of {1} quizzes - Upgrade to unlock unlimited quizzes and access quizzes past your limit.'
              ).format(displayQuizCount, quizLimit.data.limit)}{' '}
              <Link
                href={HELP_ARTICLE_LINKS.CHOOSING_RIGHT_PLAN}
                target="_blank"
              >
                {translate('Learn More')}
              </Link>
            </div>
            <SmallButton
              appearance="warning"
              onClick={() => {
                new ViewPricingTableEventAdapter({
                  source: 'paywall',
                  paywall_feature: PaywallScreens.QuizListLimitBanner,
                }).sendAnalytics();
                window.SOCRATIVE.teacherRouter.routeToPricing();
              }}
            >
              {translate('Upgrade')}
            </SmallButton>
          </div>
        </AlertMessage>
      </div>
    </div>
  );
}
